import React from 'react';

function PageLoader() {
  return (
    <div
      className="page-loader"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: '1rem',
        fontFamily: 'Inter, sans-serif',
        color: '#6b7280'
      }}
    >
      <div>Loading...</div>
    </div>
  );
}

export default PageLoader;
